import styled from 'styled-components';

import { CartItemButton } from 'pages/cart/cart-item/styles';
import { SectionHeading } from 'pages/cart/section-heading';
import { brandFont } from 'styles/brand-font';

export const UpsellCarouselWrapper = styled.div`
  margin-block-start: 0;
  margin-block-end: 1rem;
  margin-inline-start: 1rem;
  margin-inline-end: 0;
  ${SectionHeading} {
    font: ${brandFont.headerThree};
    margin-block-start: 1.5rem;
    margin-block-end: 0.5rem;
    margin-inline: 0;
  }
  ${Styles.desktop} {
    ${CartItemButton} {
      box-shadow: none;
    }
  }
`;
